<template>
  <PreloaderComponent v-if="loading" />
  <div v-else class="faq">
    <kid-components
      v-if="need_kid"
      :contract_id="contract_id"
      :project_link="project_link"
    />
    <constructor-component
      v-if="!need_kid"
      :contract_id="contract_id"
      :project_link="project_link"
      :rules="rules"
      :type="type"
    />
  </div>
</template>

<script>
import KidComponents from "@/profile/components/KidComponents.vue";
import ConstructorComponent from "@/profile/components/ConstructorComponent.vue";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import { url, b2burl } from "@/profile/composables/url";
import axios from "axios";

export default {
  data: () => {
    return {
      contract_id: "",
      need_kid: true,
      loading: true,
      project_link: "",
      rules: "",
      type: ""
    };
  },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData();
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      let params = {
        command: "constructor_dogovors",
        token: this.$myApp.token.get()
      };
      let $this = this;
      axios
        .post(url, {
          params: params
        })
        .then(function(response) {
          let data = response.data;
          if (data.state === "ERR") {
            $this.errors = [];
            $this.errors.push(data.msg_text);
          }
          if (data.state === "OK") {
            $this.loading = false;
            $this.contract_id = data.contracts[0].NEW_ID;
            $this.need_kid = data.contracts[0].NEED_KID;
            $this.rules = data.contracts[0].RULES;
            $this.project_link = b2burl + data.contracts[0].SLUG + "/";
            $this.type = data.contracts[0].PROGRAM_RULE;
          }
        })
        .catch(function(error) {
          console.log(error);
          $this.errors = [];
          $this.errors.push("Возникла ошибка, попробуйте позже");
          $this.loading = false;
        });
    }
  },
  components: {
    KidComponents,
    PreloaderComponent,
    ConstructorComponent
  }
};
</script>

<style>

</style>